import type { RoleConfig } from '../types.js';

export const monk: RoleConfig = {
  id: 'monk',
  faction: 'town',
  title: { ru: 'Монах', uk: 'Монах' },
  latin: 'MONK',
  number: '34',
  accent: '#c9a86a',
  sub: '#7a5a3a',
  ability: {
    ru: 'Раз за игру накладывает обет молчания — цель не действует ни этой, ни следующей ночью.',
    uk: 'Один раз за гру накладає обітницю мовчання — ціль не діє ані цієї, ані наступної ночі.',
  },
  abilities: [
    {
      key: 'silence',
      phase: 'night',
      cadence: 'one-time',
      canSelfTarget: false,
      charges: 1,
    },
  ],
  victory: { type: 'town' },
};
